import maplibregl, {FullscreenControl, GeolocateControl} from 'maplibre-gl';

class Controls {
    constructor(map) {
        this.map = map;

        this.setup();
    }

    setup() {
        // Define our own attribution to remove the "MapLibre" part
        this.map.addControl(
            new maplibregl.AttributionControl({
                compact: true,
            })
        );

        this.map.addControl(
            new maplibregl.NavigationControl()
        );

        this.map.addControl(
            new FullscreenControl()
        );

        this.map.addControl(
            new GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            })
        );
    }
}

export default Controls;
